import React, { Component,useState,useEffect } from 'react'
// import data from './projects.json'
import { faTimes,faPaperPlane } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {Card,CardDeck,CardColumns, Container, Row, Col,Toast,Button,Spinner,Alert} from "react-bootstrap";
import {Link} from "react-router-dom"
import classes from './Page1.module.css'
import axios from 'axios'
// import "./Page1.module.css";

// "data": {
//     "chatbox": [
//       {
//         "admin": false,
//         "_id": "609515f182dba153d854a880",
//         "timestamp": "dummy",
//         "name": "prachi",
//         "messagebody": "Interested in pcell",
//         "email": "prachi@pcell.com",
//         "__v": 0
//       },
//       {
//         "admin": false,
//         "_id": "6095161b82dba153d854a881",
//         "timestamp": "dummy",
//         "name": "Brendan",
//         "messagebody": "Interested in pcell",
//         "email": "brendyyyboy@pcell.com",
//         "__v": 0
//       },
//       {
//         "admin": false,
//         "_id": "6095162b82dba153d854a882",
//         "timestamp": "dummy",
//         "name": "colin",
//         "messagebody": "Interested in pcell",
//         "email": "colin@pcell.com",
//         "__v": 0
//       },
//       {
//         "admin": false,
//         "_id": "6095164482dba153d854a883",
//         "timestamp": "dummy",
//         "name": "colin",
//         "messagebody": "Can the meeting be earlier?",
//         "__v": 0
//       }
//     ]
//   }

function Announcement(props) {
    const [obj_announce,setObj_announce] = useState([])
    const [reload,setReload] = useState(false)
    // const [count,setCount] = useState(0)
    let count =0
    const [new_announcement,setNew_announcement] =useState({timestamp:"",title:"",adminmessage:""})
    const [new_message,setNew_message]=useState({admin: false,timestamp: "",name: "",messagebody: "",email:""})
    const [send_announcement,setSend_announcement] = useState(false)
    const [obj_chat,setObj_chat] = useState([])
    const [send_message,setSend_message] = useState(false)
    const [spin,setSpin] = useState(false)
    const [mails,setMails] = useState([])
    const [alert_bar,setAlert_Bar] = useState(false)
    useEffect(()=>{
            axios.get("https://lime-rich-spider.cyclic.app/api/v1/Home/announcements")
            .then(resp=>{{/*console.log(resp)*/};setObj_announce(resp.data.data.meeting.reverse())})
            .catch(err=>{console.log(err);})
            axios.get("https://lime-rich-spider.cyclic.app/api/v1/Home/chatbox")
            .then(resp=>{{/*console.log(resp)*/};setObj_chat(resp.data.data.chatbox.reverse())})
            .catch(err=>{console.log(err);})
            axios.get(`https://lime-rich-spider.cyclic.app/api/v1/Home/emailID`)
            .then(response =>{{/*console.log(response)*/};setMails(response.data.data.email)})
            .catch(error => {console.log(error)})  
    },[])

    useEffect(()=>{
        if (reload) {
            if (props.isLoggedIn==="true") {
                axios.get("https://lime-rich-spider.cyclic.app/api/v1/Home/announcements")
                    .then(resp=>{{/*console.log(resp)*/};setObj_announce(resp.data.data.meeting.reverse())})
                    .catch(err=>{console.log(err);})
            }
            axios.get("https://lime-rich-spider.cyclic.app/api/v1/Home/chatbox")
            .then(resp=>{{/*console.log(resp)*/};setObj_chat(resp.data.data.chatbox.reverse())})
            .catch(err=>{console.log(err);})
            setReload(false)
            setSpin(false)
        }
    },[reload])
    useEffect(()=>{
        if(send_announcement)
        {   let mail_list = mails.map(obj=>{return(obj.emailID)})
            let send_mail = {emailID:mail_list,subject:new_announcement.title,text:new_announcement.adminmessage}
            // console.log(send_mail);
            axios.post(`https://lime-rich-spider.cyclic.app/api/v1/Home/send`,send_mail)
                .then(response =>{/*console.log(response)*/})
                .catch(error => {console.log(error)})  
            axios.post("https://lime-rich-spider.cyclic.app/api/v1/Home/announcements",new_announcement)
                .then(resp=>{/*console.log(resp)*/;setReload(true);setNew_announcement({timestamp:"",title:"",adminmessage:""})})
                .catch(err=>{console.log(err);})
            setSend_announcement(false)
        }

    },[send_announcement,new_announcement])
    useEffect(()=>{
        if(send_message)
        {
            setSpin(<Spinner animation="border" variant="primary"/>)
            console.log(new_message);
            axios.post("https://lime-rich-spider.cyclic.app/api/v1/Home/chatbox",new_message)
                .then(resp=>{{/*console.log(resp)*/};setReload(true);setNew_message({...new_message,timestamp: "",messagebody: ""})})
                .catch(err=>{console.log(err);})
            setSend_message(false)
        }

    },[send_message,new_message])

    const delete_chat=(id)=>{
        console.log(`https://lime-rich-spider.cyclic.app/api/v1/Home/chatbox/${id}`);
        axios.delete(`https://lime-rich-spider.cyclic.app/api/v1/Home/chatbox/${id}`)
            .then(resp=>{console.log(resp);setReload(true)})
            .catch(err=>{console.log(err);})
    }

    const delete_announcement=(id)=>{
        console.log(`https://lime-rich-spider.cyclic.app/api/v1/Home/announcements/${id}`);
        axios.delete(`https://lime-rich-spider.cyclic.app/api/v1/Home/announcements/${id}`)
            .then(resp=>{console.log(resp);setReload(true)})
            .catch(err=>{console.log(err);})
    }
    let new_date
    let some_style = props.isLoggedIn==="true"?{overflow:"auto",minHeight:"64vh",maxHeight:"64vh"}:{overflow:"auto",minHeight:"83vh",maxHeight:"83vh"}
    let chat_style = props.isLoggedIn==="true"?{overflow:"auto",minHeight:"66vh",maxHeight:"66vh",backgroundColor:"#cecece",borderColor:"black",marginRight:"40px",borderWidth:"1px",borderStyle:"solid",display:"flex",flexDirection:"column-reverse"}:{overflow:"auto",minHeight:"70vh",maxHeight:"70vh",backgroundColor:"#cecece",borderColor:"black",marginRight:"40px",borderWidth:"1px",borderStyle:"solid",display:"flex",flexDirection:"column-reverse"}
    useEffect(() => {
        const interval = setInterval(() => {
          setReload(true);console.log("Now Reloading");
        }, 30000);
        return () => clearInterval(interval);
      }, []);

      const validate=()=>{
          if (new_message.name!==""&&new_message.messagebody!==""&&new_message.email!=="") {
            setNew_message({...new_message,timestamp:new Date().toLocaleString("en-IN")});
            setSend_message(true)
            setAlert_Bar(false)
          }
          if (new_message.name==="")
          {
              setAlert_Bar(<Alert key={0} variant="danger"><h5>Kindly fill your name</h5></Alert>)
          } else if(new_message.email==="")
          {
            setAlert_Bar(<Alert key={0} variant="danger"><h5>Kindly fill your EmailID</h5></Alert>)
          }
          else if(new_message.messagebody==="")
          {
            setAlert_Bar(<Alert key={0} variant="danger"><h5>Message cannot be empty</h5></Alert>)
          }
      }
    return (

//<div className="FixedHeightContainer" style={{width:"250px",height:"250px",backgroundColor:"red",float:"right",padding:"3px"}}>
//   <h2>Title</h2>
//   <div className="Content" style={{height:"224px",overflow:"auto",backgroundColor:"#fff"}}>
//    blah... ..blah blah blah... ..blah blah blah... ..blah blah blah... ..blah blah blah... ..blah blah blah... ..blah blah blah... ..blah blah blah... ..blah blah blah... ..blah blah blah... ..blah blah blah... ..blah blah blah... ..blah blah blah... ..blah blah blah... ..blah blah blah... ..blah blah blah... ..blah blah blah... ..blah blah blah... ..blah blah blah... ..blah blah blah... ..blah blah blah... ..blah blah blah... ..blah blah blah... ..blah blah blah... ..blah blah blah... ..blah blah blah... ..blah blah blah... ..blah blah blah... ..blah blah blah... ..blah blah blah... ..blah blah blah... ..blah blah blah... ..blah blah blah... ..blah blah blah... ..blah blah blah... ..blah blah blah... ..blah blah blah... ..blah blah blah... ..blah blah blah... ..blah blah blah... ..blah blah blah... ..blah blah blah... ..blah blah blah... ..blah blah blah... ..blah blah blah... ..blah blah blah... ..blah blah blah... ..blah blah blah... ..blah blah blah... ..blah blah blah... ..blah blah blah... ..blah blah blah... ..blah blah blah... ..blah blah blah... ..blah blah blah... ..blah blah blah...
//   </div>
// </div>
<div style={{marginLeft:'5px',paddingTop:"35px",}}>
          <Row className="justify-content-md-center" style={{minHeight:"89vh"}}>
         <Col md={4} style={{backgroundColor:"#62c2ee"}}>
        <h2 style={{color:"white"}}>Announcement Page</h2>  
                
                <div style={some_style}>
                {/* {obj_announce.reverse()} */}
                {obj_announce.map((obj,index)=>{
                    new_date = new Date(obj.timestamp)
                    return(
                    <Toast key={obj._id} style={{margin:"15px",minWidth:"90%"}}>
                 <Toast.Header closeButton={false} style={{backgroundColor:"#030835",color:"white"}}>
                     <strong className="mr-auto">{obj.title}</strong>
                     <small>{new_date.toLocaleString()}</small>
                     {props.isLoggedIn==="true"&&<span style={{marginLeft:"7px",cursor:"pointer"}} onClick={()=>{delete_announcement(obj._id)}}><FontAwesomeIcon icon={faTimes}/></span>}
                 </Toast.Header>
                 <Toast.Body>
                     {obj.adminmessage}
                 </Toast.Body>
                 </Toast>  
                    )
                })}
                
                 
                 </div>
                 {props.isLoggedIn==="true"&&<Row style={{margin:"20px"}}>
                     <Col md={10}>
                    <input type="text" style={{marginBottom:"10px",width:"100%"}} placeholder="Announcement Title" value={new_announcement.title} onChange={e=>{setNew_announcement({...new_announcement,title: e.target.value})}}/>
                    <textarea style={{height:"100px",width:"100%"}} placeholder="Announcement Text" value={new_announcement.adminmessage} onChange={e=>{setNew_announcement({...new_announcement,adminmessage: e.target.value})}}/>
                     </Col>
                     <Col md={2}>
                    <Button  onClick={()=>{setNew_announcement({...new_announcement,timestamp:new Date().toLocaleString("en-IN")});setSend_announcement(true)}}>Send <FontAwesomeIcon icon={faPaperPlane}/></Button>
                     </Col>
                 </Row>}
         </Col>
         <Col md={8} style={{backgroundColor:"#fff"}}>

         <h2 style={{color:"black"}}>Chat Forum</h2>   
                <div style={chat_style}>
                {obj_chat.map((obj,index)=>{
                    new_date = new Date(obj.timestamp)
                    if (obj.admin) {
                        return(
                            <div key={obj._id} style={{textAlign:"start",margin:"2px",marginLeft:"10px"}}>
                             <div style={{backgroundColor:"#030835",color:"white",padding:"10px",borderRadius:"20px",display:"inline-block",maxWidth:"70%"}}>
                                 {obj.name} {props.isLoggedIn==="true"&&<span style={{marginLeft:"7px",cursor:"pointer"}} onClick={()=>{delete_chat(obj._id)}}><FontAwesomeIcon icon={faTimes}/></span>}
                                 <h6>{obj.messagebody}</h6>
                                 <span className="text-muted">{new_date.toLocaleString()}</span>
                            </div>
                             {/* <span style={{backgroundColor:"red",color:"white",padding:"10px",borderRadius:"25px"}}>{obj.messagebody}{obj.name}</span> */}
                             </div> 
                                )
                    } else {
                        return(
                            <div key={obj._id} style={{textAlign:"end",margin:"2px",marginRight:"10px"}}>
                             <div style={{backgroundColor:"#62c2ee",color:"#000",padding:"10px",borderRadius:"20px",display:"inline-block",maxWidth:"70%"}}>
                                    {obj.name} {props.isLoggedIn==="true"&&<span style={{marginLeft:"7px",cursor:"pointer"}} onClick={()=>{delete_chat(obj._id)}}><FontAwesomeIcon icon={faTimes}/></span>}
                                 <h6>{obj.messagebody}</h6>
                                 <span>{props.isLoggedIn==="true"&&obj.email}</span> <span className="text-muted">{new_date.toLocaleString()}</span>
                            </div>
                             {/* <span style={{backgroundColor:"red",color:"white",padding:"10px",borderRadius:"25px"}}>{obj.messagebody}{obj.name}</span> */}
                             </div> 
                                )
                    }
                    
                })} 
                 </div>
                 {props.isLoggedIn==="true"&&<Row style={{margin:"20px"}}>
                     <Col md={10}>
                    {/* <input type="text" style={{marginBottom:"10px",width:"100%"}} placeholder="Announcement Title" value={new_announcement.title} onChange={e=>{setNew_announcement({...new_announcement,title: e.target.value})}}/> */}
                    <textarea style={{height:"100px",width:"100%"}}  placeholder="Message From Admin to Forum" value={new_message.messagebody} onChange={e=>{setNew_message({...new_message,messagebody: e.target.value})}}/>
                     </Col>
                     <Col md={2}>
                    <Button style={{marginBottom:"8px"}} onClick={()=>{setNew_message({...new_message,admin:true,name:"admin",email:"projectcellcrce@gmail.com",timestamp:new Date().toLocaleString("en-IN")});setSend_message(true)}} >Send <FontAwesomeIcon icon={faPaperPlane}/></Button>
                     {spin}
                     </Col>
                 </Row>}

                 {props.isLoggedIn==="false"&&<Row style={{margin:"20px"}}>
                     <Col md={10}>
                        {alert_bar}
                    <Row>
                        <Col md={6}>
                            <input type="text" style={{marginBottom:"10px",width:"100%"}} className={classes.Login} placeholder="Your Name" value={new_message.name} onChange={e=>{setNew_message({...new_message,name: e.target.value})}}/>
                        </Col>
                        <Col md={6}>
                            <input type="email" style={{marginBottom:"10px",width:"100%"}} className={classes.Login} placeholder="Your Email" value={new_message.email} onChange={e=>{setNew_message({...new_message,email: e.target.value})}}/>
                        </Col>
                    </Row>
                    <input type="text" style={{width:"100%"}} className={classes.Login} placeholder="Your Message" value={new_message.messagebody} onChange={e=>{setNew_message({...new_message,messagebody: e.target.value})}}/>
                     </Col>
                     <Col md={2} style={{textAlign:"center"}}>
                    <Button style={{marginBottom:"8px"}} onClick={()=>{validate()}} >Send <FontAwesomeIcon icon={faPaperPlane}/></Button>
                     {spin}
                     </Col>
                 </Row>}

         </Col>
         </Row> 
        </div>
    )
}

export default Announcement
